import { isBooksyCom } from '@booksy-com/vue-tools'

let marketingConsentGranted = false
let listenersRegistered = false

function refreshMarketingConsent (): void {
  marketingConsentGranted = Boolean(window.Cookiebot?.consent?.marketing)
}

function ensureListenersRegistered (): void {
  if (listenersRegistered) {
    return
  }

  listenersRegistered = true
  window.addEventListener('CookiebotOnConsentReady', refreshMarketingConsent)
  window.addEventListener('CookiebotOnAccept', refreshMarketingConsent)
  window.addEventListener('CookiebotOnDecline', refreshMarketingConsent)
  refreshMarketingConsent()
}

/**
 * Fails closed to `false` in production when Cookiebot is absent or marketing consent has
 * not been granted; kept in sync with Cookiebot via the same window events vue-tools listens
 * to. Non-production keeps the existing `marketing: true` dev override used for
 * `useBooksySegment` (`segment.ts`), so local/test environments are unaffected.
 */
export function isMarketingConsentGranted (): boolean {
  if (!isBooksyCom()) {
    return true
  }

  ensureListenersRegistered()

  return marketingConsentGranted
}
